export const workflowExecutions = $axios => ({
  get: workflowExecutionId => $axios.$get(`/workflow_executions/${workflowExecutionId}`),
});
